import {
  PAYPAL_ORDER_BINDING_CONTEXT_ID,
  PAYPAL_CHECKOUT_PAGE_ROOT_CONTEXT_ID,
  PAYPAL_CHECKOUT_PAGE_ROOT_CONTEXT_TYPE_ID,
} from './identifiers';

import type {
  BindingContextDef,
  BindingContextTypeDef,
  TypeReferenceBuilder,
  BindingContextRelationshipDef,
} from '@packages/systems/dynamo/source-types';

export const paypalCheckoutPageRootContextType: BindingContextTypeDef = {
  entity: 'PageRoot',
  id: PAYPAL_CHECKOUT_PAGE_ROOT_CONTEXT_TYPE_ID,
  label: 'Checkout (PayPal) Page Root',
  iconName: 'product',
};

export function paypalCheckoutPageRootContext<RootTRef, EntityTRef, ListTRef>(
  typeReferenceBuilder: TypeReferenceBuilder<RootTRef, EntityTRef, ListTRef>
): BindingContextDef<RootTRef, EntityTRef, ListTRef> {
  return {
    variant: 'Page',
    id: PAYPAL_CHECKOUT_PAGE_ROOT_CONTEXT_ID,
    label: 'Checkout (PayPal)',
    type: typeReferenceBuilder.entityOf({
      entity: 'PageRoot',
      id: PAYPAL_CHECKOUT_PAGE_ROOT_CONTEXT_TYPE_ID,
    }),
    matchPage: (page) => page.utilKey === 'ecommerce-paypal-checkout',
  };
}

export function paypalCheckoutPageRelationships<RootTRef, EntityTRef, ListTRef>(
  typeReferenceBuilder: TypeReferenceBuilder<RootTRef, EntityTRef, ListTRef>
): BindingContextRelationshipDef<RootTRef, EntityTRef> {
  return {
    type: typeReferenceBuilder.entityOf({
      entity: 'PageRoot',
      id: PAYPAL_CHECKOUT_PAGE_ROOT_CONTEXT_TYPE_ID,
    }),
    relativeContexts: [PAYPAL_ORDER_BINDING_CONTEXT_ID],
  };
}
